export const COLOR_THEMES = {
    green: {
      textColor: "text-green-400",
    },
    yellow: {
      textColor: "text-yellow-400",
    },
    orange: {
      textColor: "text-orange-400",
    },
    teal: {
      textColor: "text-brand-teal",
    },
  } as const;
